import { PlaneGeometry, Mesh, TextureLoader, Vector3, MeshBasicMaterial, Geometry, LinearMipMapLinearFilter, Fog, ShaderMaterial, Color } from 'three';
import vertexShader from './shaders/vertexShader';
import fragmentShader from './shaders/fragmentShader';

// sky handles the background, fog, and clouds
// the clouds are looped as a 'treadmill' over a static cloud bed image 
export default class Sky {
  constructor(scene, camera) {
    this.camera = camera;
    this.scene = scene;

    this.fogColor = 'rgba(201,225,245,255)';
    this.initBackground();
    this.initSceneFog(scene);

    this.cloudCount = 250;
    this.cloudBedSpawn = -this.cloudCount * 10;
       
    const mat = this.getCloudShaderMat();
    this.cloudBeds = [];
    this.cloudBeds.push(this.createCloudBed(mat, -this.cloudCount * 5));
    this.cloudBeds.push(this.createCloudBed(mat, this.cloudBedSpawn));

    this.cloudSpeed = 0.1;

    this.horizon = this.createHorizon(scene, 0); 
  }

  initBackground() {
    const loader = new TextureLoader();
    const texture = loader.load('assets/images/sky/SkyRamp_OptionB.jpg');
    this.scene.background = texture;
  }

  initSceneFog(scene) {
    scene.fog = new Fog(this.fogColor, -100, 1000);
  }

  getCloudShaderMat() {
    const texture = new TextureLoader().load('assets/images/clouds/cloud.png');
    texture.fog = true;
    texture.magFilter = LinearMipMapLinearFilter;
    texture.minFilter = LinearMipMapLinearFilter;

    // ~navy blue: matches the color of the horizon
    // const fogColor = 'rgb(161, 207, 241)';
    const fog = new Fog(this.fogColor, 100, 1500);

    const material = new ShaderMaterial({

      uniforms: {

        map: { type: 't', value: texture },
        fogColor: { type: 'c', value: fog.color },
        fogNear: { type: 'f', value: fog.near },
        fogFar: { type: 'f', value: fog.far },

      },
      vertexShader,
      fragmentShader,
      depthWrite: false,
      depthTest: false,
      transparent: true,

    });

    return material;
  }

  createCloudBed(material, z) {
    const geometry = new Geometry();
    const plane = new Mesh(new PlaneGeometry(64, 64));

    for (let i = 0; i < this.cloudCount; i += 1) {
      plane.position.x = Math.random() * 1500 - 750;
      plane.position.y = -Math.random() * Math.random() * 200 - 15;
      plane.position.z = i * 5;
      plane.scale.x = Math.random() * Math.random() * 2.0 + 2.5;
      plane.scale.y = Math.random() * Math.random() * 1.25 + 1.25;

      plane.updateMatrix();
      geometry.merge(plane.geometry, plane.matrix);
    }

    const cloudBed = new Mesh(geometry, material);
    cloudBed.position.z = z;
    cloudBed.position.y = -100;
    cloudBed.renderOrder = 1;
    this.scene.add(cloudBed);

    return cloudBed;
  }

  createHorizon(scene, z) {
    const map = new TextureLoader().load('assets/images/CloudBedTiled.jpg');
    const material = new MeshBasicMaterial({ map, transparent: true });
    material.opacity = 1;

    material.color = new Color(this.fogColor);

    const geometry = new PlaneGeometry(2000, 2000, 1);

    const plane = new Mesh(geometry, material);
    plane.position.set(0, -50, z);
    plane.rotateOnAxis(new Vector3(1, 0, 0), 0 - Math.PI / 2);
    plane.renderOrder = 0;
    scene.add(plane);

    return plane;
  }

  update() {
    this.cloudBeds.forEach((cloudBed) => {
      cloudBed.position.z += this.cloudSpeed;
      if (cloudBed.position.z > 0) cloudBed.position.z = this.cloudBedSpawn;
    });
  }
}
